// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .my-navbar {
  position: relative;
}

.header-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
}

.c-navbar {
  position: relative;
  height: 64px;
}

.navbar__nav {
  display: flex;
  justify-content: end;
  align-items: center;
  list-style: none;
  height: 100%;
  gap: 6px;
}

.my-navbar {
  height: 64px;
}

.c-navbar__brand, .c-navbar__brand-logo {
  height: 64px;
}

.c-navbar__nav-content {
  line-height: 64px;
}

.menu-bar--button {
  cursor: pointer;
  padding: 13px 27px !important;
  border-left: 4px solid transparent;
  transition: border-color 0.2s ease-in-out;
}
.menu-bar--button:hover {
  border-color: var(--color-blue-50, #6CACE4);
}

.menu-bar-icon {
  padding-top: 12px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
